import {React, useState} from 'react';
import './App-Dark.scss';
import { withTheme } from '../Theme';

//MATERIAL UI =========
//button
import Button from '@material-ui/core/Button';

//slider
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import VolumeDown from '@material-ui/icons/VolumeDown';
import VolumeUp from '@material-ui/icons/VolumeUp';

//radio btns
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

//select
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

//txt field
import TextField from '@material-ui/core/TextField';

//switch
import Switch from '@material-ui/core/Switch';

//=====================


//FIREBASE --------
import firebase from 'firebase';
import '../Firebase.js';
//-----------------

//PLAYER JS ---------------------
import player from '../Player.js';
//-------------------------------

//PLAYER FUNCTIONS ----------------------
var btn = player.btn;
var volume = player.volume;
var pato = player.ato;
var change = player.change;
//---------------------------------------



//for selector
const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 50,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));


function App(props) {
    //NOTE the majority of functions happens in player.js

    //curently selected sound
    const [selectedSound, updSelectedSound] = useState('rain');
    const [selectedSoundLabel, updSelectedSoundLabel] = useState('Rain with wind.');

    //ATO (Auto Turn Off)
    //const [atoState, togAto] = useState(false);
    const [atoState, togAto] = useState(false);
    const [amt, setAmt] = useState(0);
    const [units, setUnits] = useState('hours');


    function ato(){
        if(!atoState){
            //determine amount of time
            let time;
            if(units === 'hours'){
                //convert hours to ms | 1h = 3600000
                time = amt*3600000;
            }else{
                //convert minutes to ms | 1m = 60000
                time = amt*60000;
            }

            //call ato in player - pass time
            pato(time)
            .then(() => {
                //uncheck switch
                togAto(false);
            });

            console.log('ATO on', amt+' '+units);
            firebase.analytics().logEvent('ATO_On', {time: amt, units: units});//fb
        }else{
            //call ato in player - pass null
            pato(null)
            .then(() => {
                //uncheck switch
                togAto(false);
            });
        }
    }

    //changes selected sound states
    function handleChange(event){
        updSelectedSound(event.target.value);

        switch (event.target.value) {
            case 'rain':
                updSelectedSoundLabel('Rain with wind.');
                change('rain');
                firebase.analytics().logEvent('rain_selected');//fb
                break;
        
            case 'nature':
                updSelectedSoundLabel('Nature.');
                change('nature');
                firebase.analytics().logEvent('nature_selected');//fb
                break;

            case 'fan':
                updSelectedSoundLabel('Fan.');
                change('fan');
                firebase.analytics().logEvent('fan_selected');//fb
                break;

            case 'airplane':
                updSelectedSoundLabel('Airplane.');
                change('airplane');
                firebase.analytics().logEvent('airplane_selected');//fb
                break;

            case 'mars':
                updSelectedSoundLabel('Winds of Mars.');
                change('mars');
                firebase.analytics().logEvent('mars_selected');//fb
                break;

            default:
                break;
        }
    }


    //for selector
    const classes = useStyles();

    //link to privacy policy and email
    var policy = <a className={'link_d'} href={'/privacy'}>privacy policy</a>;

    //link to lightmode
    var lightmode = <a className={'link_d'} href={'/'}>Light Mode</a>;

    return (
        <div className='background_d'>
            
            <div className='main_d'>
                <h1 className='title_d'>fuzzynoise.com</h1>
                <h3 className='text_d'>Sounds run infinitely without interuptions.</h3>
                <h3 className='textColor_d'>Why not share? It's free.</h3>

                <h5 className='miniText_d'>Audio is not streamed. Does not require a continued internet connection.</h5>
                <h5 className='miniText_d'>By using fuzzynoise.com you agree to our {policy}. | fuzzynoise.contact@gmail.com</h5>
                
                <h5 className='miniText_d'>{lightmode}</h5>

                <div className='spacer_d'></div>

                <h2 className='textColor_d'>Play Sound</h2>
                <div className='line_d'></div>

                <div className='btnDiv_d'>
                    <h3 className='textColor_d'>{selectedSoundLabel}</h3>
                    {/*<button className='btn' onClick={() => btn()}>Play/Pause</button>*/}
                    <div className='btn_d'>
                        <Button variant="contained" color="primary" disableElevation onClick={() => {btn()}}>
                            Play/Pause
                        </Button>
                    </div>
                </div>


                <div className='slider_d'>
                    <Typography id="continuous-slider" className='textColor_d' gutterBottom>
                        Volume
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item>
                            <VolumeDown classes={{ root: 'textColor_d' }} />
                        </Grid>
                        <Grid item xs>
                            <Slider 
                            defaultValue={30}
                            aria-labelledby="continuous-slider" 
                            onChange={(event, value) => {
                                volume(value/100);
                            }}
                            />
                        </Grid>
                        <Grid item>
                            <VolumeUp classes={{ root: 'textColor_d' }} />
                        </Grid>
                    </Grid>
                </div>

                <div className='radio_d'>
                <FormControl component="fieldset">
                    <FormLabel component="legend">Select Sound</FormLabel>
                    <RadioGroup aria-label="sounds" value={selectedSound} name="sounds" onChange={event => {handleChange(event)}}>
                        <FormControlLabel value="rain" control={<Radio color="primary" />} label="Rain with wind." classes={{ label: 'textColor_d' }} />
                        <FormControlLabel value="nature" control={<Radio color="primary" />} label="Nature." classes={{ label: 'textColor_d' }} />
                        <FormControlLabel value="fan" control={<Radio color="primary" />} label="Fan." classes={{ label: 'textColor_d' }} />
                        <FormControlLabel value="airplane" control={<Radio color="primary" />} label="Airplane." classes={{ label: 'textColor_d' }} />
                        <FormControlLabel value="mars" control={<Radio color="primary" />} label="Winds of Mars." classes={{ label: 'textColor_d' }} />
                    </RadioGroup>
                </FormControl>
                </div>
                
                <div className='atoTitle_d'>
                    <h3 className='textColor_d'>Auto Turn Off</h3>

                    <FormControlLabel
                        control={
                        <Switch
                            //defaultChecked={false}
                            checked={atoState}
                            onChange={event => {togAto(event.target.checked); ato();}}
                            //name="checkedB"
                            color="primary"
                        />
                        }
                        label="On"
                        classes={{ label: 'textColor_d' }}
                    />
                </div>

                <div className='atoDiv_d'>
                    <TextField label="amount of time" type='number' variant="outlined" size='medium' 
                    value={amt} onChange={event => setAmt(event.target.value <= 0 ? 0 : event.target.value)}/>

                    <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label"></InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={units ? units : 'hours'}
                            onChange={event => setUnits(event.target.value)}
                        >
                            <MenuItem value={'hours'}>hours</MenuItem>
                            <MenuItem value={'minutes'}>minutes</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                <div className='spacer_d'></div>
            </div>
        </div>
    );
}

export default withTheme(App);